var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgG06(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80.943,
    height: 80.948,
    viewBox: "0 0 80.943 80.948",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.943,
    height: 80.948,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80.943,
    height: 80.948,
    fill: "#26bde3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.971,16.458c.048-.914.433-1.492,1.3-1.492.938,0,1.3.578,1.3,1.638v2.84c0,1.035-.384,1.637-1.323,1.637-.916,0-1.276-.626-1.276-1.637Zm1.276,6.862c2.912,0,4.044-1.59,4.044-4.117V16.8c0-2.672-1.059-4.019-3.034-4.019A2.349,2.349,0,0,0,10.994,14.1h-.023V10.585c0-.988.313-1.685,1.3-1.685s1.276.578,1.276,1.589v1.083h2.5V10.7c0-2.407-.795-4.091-3.828-4.091-2.888,0-3.972,1.853-3.972,4.4v7.944c0,2.528,1.108,4.358,4,4.358",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.346,39.01a3.651,3.651,0,0,0-2.774.168c-3.643,1.477-6.123,2.008-9.956.808-2.413-.755-4.671-2.337-7.34-1.374a15.142,15.142,0,0,1-5.425,1.23l-1.157-5.931H54.177ZM44.03,56.621a4.711,4.711,0,0,1-3.5,1.222,4.713,4.713,0,0,1-3.508-1.222,5.2,5.2,0,0,1-.649-6.346c.473-.885,3.853-5.961,4.144-6.393v-.034l.013.016.012-.016v.034c.283.432,3.668,5.508,4.141,6.393a5.2,5.2,0,0,1-.649,6.346M55.38,32.732a.353.353,0,0,0-.266-.116H25.748a.331.331,0,0,0-.337.394l4.934,29.839a.344.344,0,0,0,.338.288h6.055L37.152,68,34.6,68l5.929,5.929,5.944-5.943-2.548,0,.414-4.852h6.162a.339.339,0,0,0,.337-.293L55.458,33.01a.354.354,0,0,0-.078-.278",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.419,21h.888l-.439-2.654h-.01Zm-1.4,2.1,1.249-6.614h1.268L26.8,23.094H25.658l-.205-1.21h-1.18l-.2,1.21Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2,18.938v4.156h-.937V16.48h1.093l1.2,3.794V16.48h.927v6.614H29.5Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.86,22.186c.458,0,.634-.273.634-.673V18.05a.579.579,0,0,0-.634-.663h-.469v4.8Zm1.746-3.931v3.063c0,1.015-.419,1.775-1.61,1.775H31.279V16.479H33c1.191,0,1.61.752,1.61,1.776",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.085,21.669v-.887h1.034v.906c0,.372.166.587.547.587.35,0,.507-.234.507-.587v-.252a1.2,1.2,0,0,0-.5-.937l-.653-.653A2.232,2.232,0,0,1,37.1,18.08v-.225A1.379,1.379,0,0,1,38.656,16.4c1.112,0,1.551.546,1.551,1.5v.536H39.192v-.575c0-.38-.176-.566-.526-.566a.488.488,0,0,0-.527.547v.135c0,.372.205.587.527.9l.712.7a2.22,2.22,0,0,1,.9,1.717v.321a1.433,1.433,0,0,1-1.619,1.552,1.378,1.378,0,0,1-1.571-1.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.993,21h.888l-.439-2.654h-.01Zm-1.4,2.1,1.249-6.614h1.268l1.259,6.614H43.232l-.2-1.21h-1.18l-.195,1.21Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.848,18.938v4.156h-.937V16.48H46l1.2,3.794V16.48h.927v6.614h-.976Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.112,
    height: 6.614,
    transform: "translate(49.019 16.48)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.668,16.48h2.956v.907h-.917v5.707H51.585V17.387h-.917Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.756,21h.888l-.439-2.654h-.01Zm-1.4,2.1L54.61,16.48h1.268l1.259,6.614H55.995l-.2-1.21H54.61l-.195,1.21Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.786,16.48h2.956v.907h-.917v5.707H57.7V17.387h-.917Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.112,
    height: 6.614,
    transform: "translate(60.328 16.48)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.427,21.563V18.012c0-.4-.176-.683-.576-.683s-.566.283-.566.683v3.551c0,.4.176.682.566.682s.576-.282.576-.682m-2.254-.176v-3.2a1.686,1.686,0,1,1,3.366,0v3.2a1.686,1.686,0,1,1-3.366,0",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.208,18.938v4.156h-.937V16.48h1.093l1.2,3.794V16.48h.927v6.614h-.976Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.147,11.63V8.43a1.56,1.56,0,0,1,1.659-1.785c1.229,0,1.57.683,1.57,1.658v.781H25.362V8.216c0-.41-.137-.644-.537-.644s-.566.283-.566.683v3.551c0,.4.166.682.566.682s.537-.253.537-.643v-1.22h1.014v1.142c0,.946-.39,1.648-1.57,1.648a1.564,1.564,0,0,1-1.659-1.785",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.077,6.723h1.112V12.43h1.327v.907H27.077Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.121,6.723h2.654V7.63H31.233V9.523h1.1v.9h-1.1v2.01h1.542v.907H30.121Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.688,11.24h.888l-.439-2.654h-.01Zm-1.4,2.1,1.249-6.614H35.81l1.258,6.614H35.927l-.2-1.21h-1.18l-.195,1.21Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.562,9.181v4.156h-.937V6.724h1.093l1.2,3.794V6.724h.927v6.614h-.976Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.607,9.25l-.624,4.087H43.939l-.888-6.614h1.073l.517,4.195h.01l.556-4.195h.907l.615,4.195h.01l.507-4.195h.936l-.858,6.614H46.27L45.617,9.25Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.588,11.24h.888l-.439-2.654h-.01Zm-1.4,2.1,1.249-6.614H50.71l1.259,6.614H50.827l-.2-1.21h-1.18l-.195,1.21Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.833,6.723h2.956V7.63h-.917v5.707H52.75V7.63h-.917Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.326,6.723H57.98V7.63H56.438V9.523h1.1v.9h-1.1v2.01H57.98v.907H55.326Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7,7.63V9.688h.371a.481.481,0,0,0,.546-.546V8.167c0-.361-.165-.537-.546-.537Zm0,2.673v3.034H58.585V6.723H60.2c1.122,0,1.532.556,1.532,1.483v.848c0,.713-.253,1.132-.888,1.278l1.064,3.005H60.741Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG06);
export default __webpack_public_path__ + "static/media/G06.7d8f257c97d13454829687a897b5724d.svg";
export { ForwardRef as ReactComponent };